import { NavBar } from './parts/nav'
import { scrollTopButton } from './parts/scroll-to-top'
import { initModals } from './parts/modal-dialogs'
import { animateEls } from './parts/animations'

let scrollTop = document.querySelector('.cd-top')
scrollTop instanceof HTMLElement && scrollTopButton(scrollTop)

let nav = document.querySelector('.menu')
nav instanceof HTMLElement && new NavBar(nav)

initModals()

let animated = document.querySelectorAll('[data-anim]')
animated.forEach((el) => animateEls(el as HTMLElement))
